import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import cx from 'classnames';
import i18n from 'i18next';
import { useSelector, useDispatch } from 'react-redux';
import $ from 'jquery';
import moment from 'moment';
import { TablePagination } from '@material-ui/core';
import { CloudOffOutlined, Assignment, CloudUpload } from '@material-ui/icons';
import PopupDialog from 'ui/components/popup-dialog';
import Progress from './ui/react-ui/progress.jsx';
import Tabs from './ui/react-ui/tabs';
import DataTable from './ui/table';
import SearchBar from './ui/searchBar';
import EventDraftEdit from './eventManagement/eventDraft-edit';
import EventTypeEdit from './eventManagement/eventType-edit';
import EventDetialDialog from './eventManagement/eventDetial-dialog.js'; // api

import { getTrafficEventTypeList, getTrafficEventList, getTrafficEventListPublished, editEventAPI, deleteEventAPI, editEventPublishStatusAPI } from '../api/eventAPI'; // redux

import { setEventTypeList, setDialogInfo, clearDialogInfo, setNewEventData, setEventDraftData, setEventPublishedData, setNewEventSort, setEventDraftSort, setPublishedSort } from '../redux/event-management';
var t = i18n.getFixedT(null, 'event-management');
var gt = i18n.getFixedT(null, 'app');
var EventManagement = /*#__PURE__*/React.memo(function (props) {
  // redux
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      contextRoot = _useSelector.envCfg.contextRoot,
      _useSelector$eventMan = _useSelector.eventManagement,
      eventTypeList = _useSelector$eventMan.eventTypeList,
      newEventSort = _useSelector$eventMan.newEventSort,
      eventDraftSort = _useSelector$eventMan.eventDraftSort,
      publishedSort = _useSelector$eventMan.publishedSort,
      newEventData = _useSelector$eventMan.newEventData,
      eventDraftData = _useSelector$eventMan.eventDraftData,
      eventPublishedData = _useSelector$eventMan.eventPublishedData;

  var dispatch = useDispatch();
  var id = props.id;

  var _useState = useState('newEvent'),
      _useState2 = _slicedToArray(_useState, 2),
      currentTab = _useState2[0],
      setCurrentTab = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      currentPage = _useState4[0],
      setCurrentPage = _useState4[1];

  var _useState5 = useState(0),
      _useState6 = _slicedToArray(_useState5, 2),
      totalCount = _useState6[0],
      setTotalCount = _useState6[1];

  var _useState7 = useState(10),
      _useState8 = _slicedToArray(_useState7, 2),
      rowsPerPage = _useState8[0],
      setRowsPerPage = _useState8[1];

  var _useState9 = useState([]),
      _useState10 = _slicedToArray(_useState9, 2),
      selectedItems = _useState10[0],
      setSelectedItems = _useState10[1];

  var _useState11 = useState(''),
      _useState12 = _slicedToArray(_useState11, 2),
      keyword = _useState12[0],
      setKeyword = _useState12[1];

  var _useState13 = useState(),
      _useState14 = _slicedToArray(_useState13, 2),
      detialData = _useState14[0],
      setDetialData = _useState14[1];

  var _isMounted = useRef(false);

  var _isResetUseState = useRef(false);

  var _currentData = useRef([]);

  var tabsMenu = [{
    key: 'newEvent',
    title: t('lbl-new-event')
  }, {
    key: 'eventDraft',
    title: t('lbl-event-draft')
  }, {
    key: 'published',
    title: t('lbl-published')
  }];

  var handleChangePage = function handleChangePage(e, newPage) {
    setCurrentPage(newPage);
  };

  var handleChangeRowsPerPage = function handleChangeRowsPerPage(e) {
    setRowsPerPage(parseInt(e.target.value, 10));
    setCurrentPage(0);
  };

  var handleSort = function handleSort(sort) {
    switch (currentTab) {
      case 'newEvent':
        dispatch(setNewEventSort(sort));

      case 'eventDraft':
        dispatch(setEventDraftSort(sort));

      case 'published':
        dispatch(setPublishedSort(sort));
    }
  };

  var handleCloseDialog = function handleCloseDialog() {
    dispatch(clearDialogInfo());
    fetchData();
    setSelectedItems([]);
  };

  var handleOpenDialog = function handleOpenDialog(type) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    if (type === 'eventType.edit') {
      var evenTypesData = _.map(_.cloneDeep(eventTypeList), function (el) {
        el.autoUnpublish = el.autoUnpublishAfterStart > -1;
        return el;
      });

      return dispatch(setDialogInfo({
        mode: type,
        data: evenTypesData
      }));
    }

    dispatch(setDialogInfo({
      mode: type,
      data: type.indexOf('edit') > -1 ? data : {}
    }));
  };

  var handleEventPublish = function handleEventPublish(itemAry, isPublish) {
    return new Promise(function (resolve, reject) {
      var callAPI = function callAPI(data) {
        editEventPublishStatusAPI(contextRoot, true, data, isPublish).then(function (result) {
          itemAry.shift();
          if (itemAry.length === 0) return resolve('ok');
          callAPI(itemAry[0]);
        });
      };

      callAPI(itemAry[0]);
    });
  };

  var handleUnpublished = function handleUnpublished(singleItem) {
    var unpublishedData = [];
    if (singleItem) unpublishedData.push(singleItem);else unpublishedData = _.filter(_.cloneDeep(_currentData.current), function (el) {
      return _.some(selectedItems, function (id) {
        return id === el.id;
      });
    });
    PopupDialog.confirm({
      title: t("dlg-unpublished-event"),
      display: t("txt-unpublished-event"),
      cancelText: gt('global.lbl-answer-cancel'),
      confirmText: gt('global.lbl-answer-ok'),
      act: function act(confirmed) {
        if (confirmed) {
          Progress.startSpin();
          handleEventPublish(unpublishedData, false).then(function (result) {
            Progress.done();
            fetchData();
            setSelectedItems([]);
          });
        }
      }
    });
  };

  var handlePublished = function handlePublished(singleItem) {
    var publishData = [];
    if (singleItem) publishData.push(_.cloneDeep(singleItem));else publishData = _.filter(_.cloneDeep(_currentData.current), function (el) {
      return _.some(selectedItems, function (id) {
        return id === el.id;
      });
    });
    PopupDialog.confirm({
      title: t("dlg-published-event"),
      display: t("txt-published-event"),
      cancelText: gt('global.lbl-answer-cancel'),
      confirmText: gt('global.lbl-answer-ok'),
      act: function act(confirmed) {
        if (confirmed) {
          Progress.startSpin();
          handleEventPublish(publishData, true).then(function (result) {
            Progress.done();
            fetchData();
            setSelectedItems([]);
          });
        }
      }
    });
  };

  var handleDelete = function handleDelete(eventData) {
    PopupDialog.confirm({
      title: t("dlg-delete-event"),
      display: t("txt-deleted-event"),
      cancelText: gt('global.lbl-answer-cancel'),
      confirmText: gt('global.lbl-answer-ok'),
      act: function act(confirmed) {
        if (confirmed) {
          deleteEventAPI(contextRoot, false, eventData).then(function (result) {
            fetchData();
          });
        }
      }
    });
  };

  var handleOpenDetailDialog = function handleOpenDetailDialog(data) {
    setDetialData(data);
  };

  var closeDetialDialog = function closeDetialDialog() {
    setDetialData(null);
  };

  var fetchData = function fetchData() {
    var isInit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var _currentPage, _rowsPerPage, _keyword;

    _currentPage = isInit ? 0 : currentPage;
    _rowsPerPage = isInit ? 10 : rowsPerPage;
    _keyword = isInit ? '' : keyword;
    var offset = (Number(_currentPage + 1) - 1) * rowsPerPage;

    switch (currentTab) {
      case 'newEvent':
        getTrafficEventList(contextRoot, false, _keyword, newEventSort, offset, _rowsPerPage, true).then(function (result) {
          var eventExternal = _.map(result.content, function (el, index) {
            return _objectSpread(_objectSpread({}, el), {}, {
              sequence: offset + index + 1
            });
          });

          dispatch(setNewEventData(eventExternal));
          setTotalCount(result.totalElements);
        });
        break;

      case 'eventDraft':
        getTrafficEventList(contextRoot, false, _keyword, eventDraftSort, offset, _rowsPerPage, false).then(function (result) {
          var eventDraft = _.map(result.content, function (el, index) {
            return _objectSpread(_objectSpread({}, el), {}, {
              sequence: offset + index + 1
            });
          });

          dispatch(setEventDraftData(eventDraft));
          setTotalCount(result.totalElements);
        });
        break;

      case 'published':
        getTrafficEventListPublished(contextRoot, false, _keyword, publishedSort, offset, _rowsPerPage).then(function (result) {
          var eventPublished = _.map(result.content, function (el, index) {
            return _objectSpread(_objectSpread({}, el), {}, {
              sequence: offset + index + 1
            });
          });

          dispatch(setEventPublishedData(eventPublished));
          setTotalCount(result.totalElements);
        });
        break;
    }
  };

  useEffect(function () {
    if (!_isMounted.current) return;
    if (!_isResetUseState.current) fetchData();
    _isResetUseState.current = false;
  }, [JSON.stringify(newEventSort), JSON.stringify(eventDraftSort), JSON.stringify(publishedSort), currentPage, rowsPerPage]);
  useEffect(function () {
    if (!_isMounted.current) return;
    if (currentPage !== 0) return setCurrentPage(0);
    if (!_isResetUseState.current) fetchData();
    _isResetUseState.current = false;
  }, [keyword]);
  useEffect(function () {
    if (!_isMounted.current) return;
    if (keyword !== '' || currentPage !== 0 || rowsPerPage !== 10 || selectedItems.length > 0) _isResetUseState.current = true;
    setCurrentPage(0);
    setRowsPerPage(10);
    setKeyword('');
    setSelectedItems([]);
    _currentData.current = [];
    fetchData(true);
  }, [currentTab]);
  useEffect(function () {
    if (!_isMounted.current) {
      var trafficEventTypeList = getTrafficEventTypeList(contextRoot, true);
      var trafficEventExternal = getTrafficEventList(contextRoot, true, '', newEventSort, 0, 10, true);
      Progress.startSpin();
      $.when(trafficEventTypeList, trafficEventExternal).then(function (result_eventType, result_eventExternal) {
        dispatch(setEventTypeList(result_eventType.content));

        var eventExternal = _.map(result_eventExternal.content, function (el, index) {
          return _objectSpread(_objectSpread({}, el), {}, {
            sequence: index + 1
          });
        });

        dispatch(setNewEventData(eventExternal));
        setTotalCount(result_eventExternal.totalElements);
        _isMounted.current = true;
        Progress.done();
      });
    }
  }, []);
  var fields = {},
      sort = null;

  _.set(fields, 'sequence', {
    label: t('lbl-sequence')
  });

  _.set(fields, 'type', {
    label: t('lbl-event-type')
  });

  _.set(fields, 'description', {
    label: t('lbl-description'),
    sortable: true,
    formatter: function formatter(val, row) {
      if (_.isEmpty(val)) return null;

      var textAry = _.split(val, /\r?\n/g);

      return textAry.length > 1 ? textAry[0] + '...' : val;
    }
  });

  _.set(fields, 'position', {
    label: t('lbl-map-position'),
    formatter: function formatter(val, row) {
      if (row.latitude === '' || row.longitude === '') return null;
      return /*#__PURE__*/React.createElement("div", null, row.latitude + ', ' + row.longitude);
    }
  });

  if (currentTab === 'newEvent') {
    _currentData.current = newEventData;
    sort = newEventSort;

    _.set(fields, 'createdAt', {
      label: t('lbl-received-time'),
      sortable: true
    });

    _.set(fields, 'source', {
      label: t('lbl-info-source')
    });

    _.set(fields, 'beginTime', {
      label: t('lbl-start-time'),
      sortable: true
    });

    _.set(fields, 'endTime', {
      label: t('lbl-end-time'),
      sortable: true
    });

    _.set(fields, 'more', {
      label: t('lbl-more'),
      formatter: function formatter(val, row) {
        return /*#__PURE__*/React.createElement("div", {
          className: "icon-block"
        }, /*#__PURE__*/React.createElement("a", {
          title: t('lbl-publish'),
          onClick: function onClick() {
            return handlePublished(row);
          }
        }, /*#__PURE__*/React.createElement("i", {
          class: "fab fa-telegram-plane"
        })), /*#__PURE__*/React.createElement("a", {
          title: t('lbl-edit'),
          onClick: function onClick() {
            return handleOpenDialog('eventDraft.edit', row);
          }
        }, /*#__PURE__*/React.createElement("i", {
          className: "fa fa-pencil-alt fa-list-alt"
        })), /*#__PURE__*/React.createElement("a", {
          title: t('lbl-delete'),
          onClick: function onClick() {
            return handleDelete(row);
          },
          className: "delete"
        }, /*#__PURE__*/React.createElement("i", {
          className: "fa fa-trash"
        })));
      }
    });
  } else if (currentTab === 'eventDraft') {
    _currentData.current = eventDraftData;
    sort = eventDraftSort;

    _.set(fields, 'createdAt', {
      label: t('lbl-created-time'),
      sortable: true
    }); // _.set(fields, 'editor', { label: t('lbl-editor'), sortable:true })


    _.set(fields, 'beginTime', {
      label: t('lbl-start-time'),
      sortable: true
    });

    _.set(fields, 'endTime', {
      label: t('lbl-end-time'),
      sortable: true
    });

    _.set(fields, 'more', {
      label: t('lbl-more'),
      formatter: function formatter(val, row) {
        return /*#__PURE__*/React.createElement("div", {
          className: "icon-block"
        }, /*#__PURE__*/React.createElement("a", {
          title: t('lbl-publish'),
          onClick: function onClick() {
            return handlePublished(row);
          }
        }, /*#__PURE__*/React.createElement("i", {
          class: "fab fa-telegram-plane"
        })), /*#__PURE__*/React.createElement("a", {
          title: t('lbl-edit'),
          onClick: function onClick() {
            return handleOpenDialog('eventDraft.edit', row);
          }
        }, /*#__PURE__*/React.createElement("i", {
          className: "fa fa-pencil-alt fa-list-alt"
        })), /*#__PURE__*/React.createElement("a", {
          title: t('lbl-delete'),
          onClick: function onClick() {
            return handleDelete(row);
          },
          className: "delete"
        }, /*#__PURE__*/React.createElement("i", {
          className: "fa fa-trash"
        })));
      }
    });
  } else {
    _currentData.current = eventPublishedData;
    sort = publishedSort;

    _.set(fields, 'createdAt', {
      label: t('lbl-created-received-time'),
      sortable: true
    });

    _.set(fields, 'source', {
      label: t('lbl-info-source'),
      sortable: true
    }); // _.set(fields, 'editor', { label: t('lbl-editor'), sortable:true })


    _.set(fields, 'beginTime', {
      label: t('lbl-start-time'),
      sortable: true
    });

    _.set(fields, 'endTime', {
      label: t('lbl-end-time'),
      sortable: true
    }); // _.set(fields, 'status', { label: t('lbl-event-status'), sortable:true })


    _.set(fields, 'more', {
      label: t('lbl-more'),
      formatter: function formatter(val, row) {
        var now = moment().valueOf();
        var endTime = moment(row.endTime).valueOf();
        var delistOrPublishDom = /*#__PURE__*/React.createElement("a", {
          title: t('lbl-delist'),
          className: "delete",
          onClick: function onClick() {
            return handleUnpublished(row);
          }
        }, /*#__PURE__*/React.createElement(CloudOffOutlined, null));

        if (endTime < now) {
          delistOrPublishDom = /*#__PURE__*/React.createElement("a", {
            title: t('lbl-re-publish'),
            onClick: function onClick() {
              return handlePublished(row);
            }
          }, /*#__PURE__*/React.createElement(CloudUpload, null));
        }

        return /*#__PURE__*/React.createElement("div", {
          className: "icon-block"
        }, delistOrPublishDom, /*#__PURE__*/React.createElement("a", {
          title: t('lbl-detial'),
          onClick: function onClick() {
            return handleOpenDetailDialog(row);
          }
        }, /*#__PURE__*/React.createElement(Assignment, null)));
      }
    });
  }

  return /*#__PURE__*/React.createElement("div", {
    id: id
  }, /*#__PURE__*/React.createElement("div", {
    className: "event-manage-headBar"
  }, /*#__PURE__*/React.createElement(SearchBar, {
    searchIconPosition: "right",
    placeholder: "Search",
    onSearch: function onSearch(searchText) {
      if (_.isEmpty(keyword) && _.isEmpty(searchText) && currentPage !== 0) return setCurrentPage(0);
      if (_.isEmpty(keyword)) fetchData();
      setKeyword(searchText);
    },
    value: keyword
  }), /*#__PURE__*/React.createElement("a", {
    className: "icon",
    onClick: function onClick() {
      return handleOpenDialog('eventType.edit');
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "fas fa-cog"
  })), currentTab === 'eventDraft' && /*#__PURE__*/React.createElement("a", {
    className: "icon",
    onClick: function onClick() {
      return handleOpenDialog('eventDraft.create');
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "fas fa-plus"
  }))), /*#__PURE__*/React.createElement(Tabs, {
    id: "g-event-manage-tabs",
    menu: tabsMenu,
    current: currentTab,
    onChange: function onChange(key) {
      return setCurrentTab(key);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "c-border c-position-rlt"
  }, /*#__PURE__*/React.createElement(DataTable, {
    fields: fields,
    data: _currentData.current,
    rowIdField: "id",
    selectable: {
      toggleAll: true
    },
    selected: selectedItems,
    onSelectionChange: function onSelectionChange(val) {
      return setSelectedItems(val);
    },
    sort: sort,
    onSort: handleSort
  })), /*#__PURE__*/React.createElement(TablePagination, {
    component: "div",
    labelRowsPerPage: t('lbl-per-page-row-count'),
    count: totalCount,
    page: currentPage,
    onChangePage: handleChangePage,
    rowsPerPage: rowsPerPage,
    onChangeRowsPerPage: handleChangeRowsPerPage
  }), /*#__PURE__*/React.createElement("div", {
    className: "footer"
  }, currentTab === 'published' && /*#__PURE__*/React.createElement("button", {
    className: cx('button'),
    onClick: function onClick() {
      handlePublished();
    },
    disabled: selectedItems.length > 0 ? false : true
  }, t('lbl-publish')), /*#__PURE__*/React.createElement("button", {
    className: cx('button', {
      'delete': currentTab === 'published'
    }),
    onClick: function onClick() {
      if (currentTab === 'published') handleUnpublished();else handlePublished();
    },
    disabled: selectedItems.length > 0 ? false : true
  }, currentTab === 'published' ? t('lbl-delist') : t('lbl-publish')))), /*#__PURE__*/React.createElement(EventDraftEdit, {
    onClose: handleCloseDialog
  }), /*#__PURE__*/React.createElement(EventTypeEdit, null), !_.isEmpty(detialData) && /*#__PURE__*/React.createElement(EventDetialDialog, {
    data: detialData,
    onClose: closeDetialDialog
  }));
});
EventManagement.defaultProps = {
  id: 'g-event-manage'
};
EventManagement.PropTypes = {
  id: PropTypes.string
};
export default EventManagement;